import { render, staticRenderFns } from "./RefsCompany.vue?vue&type=template&id=4be2da89&scoped=true&"
import script from "./RefsCompany.vue?vue&type=script&lang=ts&"
export * from "./RefsCompany.vue?vue&type=script&lang=ts&"
import style0 from "./RefsCompany.vue?vue&type=style&index=0&id=4be2da89&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be2da89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VIcon,VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VListItemTitle,VSkeletonLoader})
